import { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
//import LanguageMenu from "../../my-data/language-menu/language-menu";
import { Box, Typography, Switch, Checkbox, Button } from "@mui/material";
import styles from './edit-card.module.scss';
import { ExportSquare } from 'iconsax-react';
import dayjs from 'dayjs';


const EditInfo = observer(({ label, uiStore, defaultable, selected, selectInfo, defaultSection, toggleDefault, initDefault }) => {
    const [country, setCountry] = useState('');
    const [state, setState] = useState('');
    const [city, setCity] = useState('');
    const [location, setLocation] = useState({ lat: 10, lng: 10, zoom: 1 });
    const [availability, setAvailability] = useState(null);
    const days = ['Saturday', 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday']
    const [infoDefault, setInfoDefault] = useState(!!initDefault);

    useEffect(() => {
        async function fetchData() {

            if (label.infoType === "address") {
                const countries = await uiStore.fetchInfoSuggestions('address');
                const sCountry = countries.find(i => i.name === label.info.country);
                setCountry(sCountry?.name + " / " + sCountry?.native);
                setState(label.info?.state);
                setCity(label.info?.city);
            }

            if (label.infoType === "location") {
                const newLocation = JSON.parse(label.info.infoValue);
                setLocation(newLocation);
            }

            if (label.infoType === 'day-time') {
                const ava = await uiStore.getAvailability(label.info?.infoValue);
                setAvailability(ava);
            }
        }

        fetchData()
    }, [label, uiStore])


    useEffect(() => {
        if (!defaultSection)
            setInfoDefault(false);
    }, [defaultSection])

    return (

        <Box className={styles.viewLabel}>
            <Checkbox sx={{ mr: 2 }} checked={selected} onChange={() => selectInfo(label._id)} />
            <Box sx={{ maxWidth: '55%', wordWrap: 'break-word' }}>
                <Typography fontSize={14} color='#888'>{label.name}</Typography>

                {label.infoType === 'date' &&
                    <>
                        {label.infoLabel === 'Birthday' ?
                            dayjs(label.info?.infoValue).format('dddd, MMM D')
                            :
                            dayjs(label.info?.infoValue).format('ddd D, MMM YYYY')
                        }
                    </>
                }

                {label.infoType === 'number' &&
                    <>
                        {label.info?.countryCode?.[0] === '+'
                            ?
                            label.info?.countryCode + ' ' + label.info?.infoValue
                            :
                            '+' + label.info?.countryCode + ' ' + label.info?.infoValue
                        }
                    </>
                }

                {label.infoType === 'location' &&
                    <Button
                        endIcon={
                            <ExportSquare
                                size="18"
                                variant="Outline"
                            />}
                        href={`https://www.google.com/maps/search/?api=1&query=${location?.lat},${location?.lng}`}
                        target="_blank"
                        rel='noopener noreferrer'
                        color="greyPrimary"
                    >

                        View Location
                    </Button>
                }

                {label.infoType === 'day-time' && availability &&
                    <Box>
                        {availability.status === 'open' &&
                            <Box>
                                {days.map(day =>
                                    <Box key={day} className={styles.avaBox}>
                                        <Typography fontWeight={500}>{day}</Typography>
                                        Available All day | Open 24 hrs
                                    </Box>
                                )}
                            </Box>
                        }
                        {availability.status === 'closed' &&
                            <Box >
                                {days.map(day =>
                                    <Box key={day} className={styles.avaBox}>
                                        <Typography fontWeight={500}>{day}</Typography>
                                        Not available | Closed
                                    </Box>
                                )}
                            </Box>
                        }
                        {availability.status === 'custom' &&
                            <Box>
                                {days.map(day =>
                                    <Box key={day} className={styles.avaBox}>
                                        <Typography fontWeight={500} fontSize={12}>{day}</Typography>
                                        {dayjs(availability[day]['from']).format('hh:mm A')} - {dayjs(availability[day]['to']).format('hh:mm A')}
                                    </Box>
                                )}
                            </Box>
                        }
                    </Box>
                }

                {label.infoType === 'address' &&
                    <Typography fontSize={14} fontWeight={600}>
                        {!!country && country}
                        {!!state && ' - ' + state}
                        {!!city && ' - ' + city}
                    </Typography>
                }

                {label.infoType !== 'number' && label.infoType !== 'date' && label.infoType !== 'location' && label.infoType !== 'day-time' && label.infoType !== 'address' &&
                    <Typography fontSize={14} fontWeight={600}>{label.info.infoValue}</Typography>
                }

            </Box>
            <Box sx={{ position: 'absolute', right: '20px', top: '20px' }}>
                {defaultable && selected &&
                    <Switch
                        color="secondary"
                        size="medium"
                        checked={infoDefault}
                        onChange={() => { toggleDefault(label.info); setInfoDefault(val => !val); }}
                    />
                }
            </Box>
        </Box>
    );

});

export default EditInfo;